/**
   * @license
   * author: Shippo Engineering <engineering@goshippo.com>
   * shippo-utilities.js v3.0.0
   * Released under the UNLICENSED license.
   */
import{useContext as r}from"react";import{FullStoryContext as o}from"./FullStoryProvider.js";const t=()=>{const t=r(o);if(!t)throw new Error("useFullStory requires the component to be wrapped in FullStoryProvider");return t};export{t as useFullStory};
//# sourceMappingURL=useFullStory.js.map
